export default ({ app, store }) => {
	// Send a custom event to the GTM container to load the GA4 tags
	window.dataLayer.push({
		event: "ga4_init",
	});
};
